import { useEffect, useRef } from "react";

const useInterval = (callback:any,delay:number):any => {
    const savedCallback = useRef();
    const jitter = Math.random();
    useEffect(() => {
        savedCallback.current= callback;
    },[callback]);

    useEffect(():any => {
        function tick(){
            (savedCallback.current as any)();
        }
        if(delay !== null){
            const id=setInterval(tick,delay + jitter);
            return () => {
                clearInterval(id)
            };
        }
    },[callback,delay,jitter])
}

export default useInterval;